export const SET_VIDEOS_DATA = '[VIDEOS] SET_VIDEOS_DATA';
export const SET_POPUP_VIDEO_ID = '[VIDEOS] SET_POPUP_VIDEO_ID';
export const RESET_POPUP_VIDEO_ID = '[VIDEOS] RESET_POPUP_VIDEO_ID';

export const setVideosData = (data) => ({
  type: SET_VIDEOS_DATA,
  payload: data,
});

export const setPopupVideoId = (id) => ({
  type: SET_POPUP_VIDEO_ID,
  payload: id,
});

export const resetPopupVideoId = () => ({
  type: RESET_POPUP_VIDEO_ID,
});
